import { ACL_TYPE } from '@openx/types/aclType.ts';
import { UserRole } from '@openx/types/user.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import {
  isAccountAllowedByAcl,
  isAllowedByCompiledAcl,
  isUserAllowedByAcl,
} from '@openx/utils/permission/validators.ts';
import { useMemo } from 'react';

export const useDealPromptPermission = () => {
  const { useIsAllowed, session } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  const accessUser = session?.user;
  const isOaInternal = useMemo(
    () =>
      !!accessUser?.roles?.includes(UserRole.NETWORK_OA_INTERNAL) ||
      isAllowed(isAllowedByCompiledAcl(ACL_TYPE.INTERNAL_FIELD_WRITE)),
    [accessUser?.roles, isAllowed]
  );

  const hasDealPrompt =
    isAllowed(isAccountAllowedByAcl(ACL_TYPE.AI_INVENTORY_DISCOVERY_ENABLED)) ||
    isAllowed(isUserAllowedByAcl(ACL_TYPE.AI_INVENTORY_DISCOVERY_ENABLED));

  const isInternalUser = isOaInternal;

  return { hasDealPrompt, isInternalUser };
};
